var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpFont6(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99357 5.00057C8.72838 5.00063 8.47406 5.10602 8.28657 5.29357L3.28657 10.2936C3.10441 10.4822 3.00362 10.7348 3.0059 10.997C3.00818 11.2592 3.11334 11.51 3.29875 11.6954C3.48416 11.8808 3.73497 11.986 3.99717 11.9882C4.25937 11.9905 4.51197 11.8897 4.70057 11.7076L8.99357 7.41357L13.2876 11.7076C13.4762 11.8897 13.7288 11.9905 13.991 11.9882C14.2532 11.986 14.504 11.8808 14.6894 11.6954C14.8748 11.51 14.98 11.2592 14.9822 10.997C14.9845 10.7348 14.8837 10.4822 14.7016 10.2936L9.70157 5.29357C9.60862 5.20059 9.49823 5.12685 9.37675 5.07658C9.25526 5.0263 9.12505 5.00047 8.99357 5.00057Z",
    fill: "#808690"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpFont6);
export default __webpack_public_path__ + "static/media/arrow_up_font6.e276f98667b7ea312d6ada65223fc38b.svg";
export { ForwardRef as ReactComponent };